import _t from 'i18n!nls/product-card';

export type MarketingTagCategory = 'job-ready' | 'job-skills' | 'bestseller' | 'top-ai-program' | 'trending-now';

export type MarketingStatusTag = {
  tag: string;
  tagName: string;
  category: MarketingTagCategory;
};

type MarketingTagSlugList = readonly [MarketingTagCategory, readonly string[]];

const JOB_READY_SLUGS: readonly string[] = [
  'aapc-medical-biller',
  'agile-atlassian-jira',
  'applied-data-science',
  'aws-cloud-solutions-architect',
  'aws-cloud-support-associate',
  'aws-cloud-technology-consultant',
  'ba-liberal-studies-georgetown',
  'bach-information-technology-illinois-tech',
  'bachelor-of-science-computer-science-bits',
  'bachelor-of-science-computer-science-london',
  'bachelor-of-science-data-science-ai-iitguwahati',
  'bachelor-of-science-general-business-unt',
  'bachelor-of-science-psychology-jgu',
  'bsc-business-administration-london',
  'bsc-data-science-huddersfield',
  'bsc-marketing-london',
  'cloud-engineering-gcp',
  'emba-iitr',
  'hrci-human-resource-associate',
  'ifp-computer-science-london',
  'imba',
  'imsa',
  'intuit-bookkeeping',
  'johns-hopkins-medical-office-manager',
  'keller-williams-real-estate-agent',
  'ma-international-relations-security-strategy-jgu',
  'ma-public-policy-jgu',
  'mas-data-science-illinois-tech',
  'mas-engineering-berkeley',
  'mas-information-technology-illinois-tech',
  'master-computer-science-clemson',
  'master-of-data-science-university-of-pittsburgh',
  'master-of-science-data-science-boulder',
  'masters-in-computer-data-science',
  'mba-business-analytics-jgu',
  'mba-illinois-tech',
  'me-engineering-management-boulder',
  'meng-computer-engineering-dartmouth',
  'meta-back-end-developer',
  'meta-front-end-developer',
  'meta-full-stack-developer',
  'microsoft-full-stack-developer',
  'microsoft-python-developer',
  'ms-artificial-intelligence-boulder',
  'ms-computer-science-ball-state',
  'ms-computer-science-boulder',
  'ms-data-analytics-engineering-northeastern',
  'ms-data-science-ball-state',
  'ms-engineering-management-northeastern',
  'ms-management-illinois',
  'msc-computer-science-heriot-watt',
  'msc-cyber-security-london',
  'msc-data-science-ul',
  'msc-management-huddersfield',
  'msee-boulder',
  'omie',
  'packt-cisco-ccna-200-301-the-complete-guide-to-getting-certified',
  'packt-comptia-security-plus-certification-sy0-701-the-total-course',
  'pearson-certified-associate-in-project-management-capm-exam',
  'sap-business-analyst',
  'sap-technology-consultant',
  'unilever-digital-marketing-analyst',
  'unt-online-bachelor-completion',
];

const JOB_SKILLS_SLUGS: readonly string[] = [
  'ai-machinelearning-essentials',
  'aws-cloud-technical-essentials',
  'aws-generative-ai-applications',
  'c-programming',
  'creative-design-tools-adobe-photoshop-illustrator-acrobat',
  'data-analytics',
  'data-engineering',
  'data-skills-for-excel',
  'design-develop-and-deploy-multi-agent-systems-with-crewai',
  'epic-games-game-design-professional-certificate',
  'excel-data-analytics-visualization',
  'facebook-marketing-analytics',
  'fast-prototyping-of-genai-apps-with-streamlit',
  'finance-quantitative-modeling-analysts',
  'gemini-for-developers',
  'gis-mapping-spatial-analysis',
  'google-cloud-cybersecurity-certificate',
  'health-informatics',
  'ibm-backend-development',
  'ibm-data-analyst',
  'ibm-data-engineer',
  'ibm-digital-marketing-and-growth-hacking',
  'ibm-full-stack-cloud-developer',
  'ibm-ios-android-mobile-app-developer-pc',
  'ibm-product-owner',
  'ibm-program-manager',
  'ibm-systems-analyst',
  'ibm-ui-ux-designer',
  'java-developer',
  'matlab-programming-engineers-scientists',
  'meta-data-analyst',
  'microsoft-business-analyst',
  'microsoft-cybersecurity-analyst',
  'microsoft-data-architecture-for-modern-data-stacks',
  'microsoft-power-bi-data-analyst',
  'microsoft-project-management',
  'packt-docker-and-kubernetes-masterclass-from-beginner-to-advanced',
  'unlock-business-insights-with-microsoft-excel-and-power-bi',
  'uol-business-and-marketing-strategies',
];

const BESTSELLER_SLUGS: readonly string[] = [
  'adp-payroll-specialist',
  'bi-analyst',
  'data-science-foundations',
  'data-science-fundamentals-python-sql',
  'decentralized-finance-duke',
  'google-agile-essentials',
  'google-data-analysis-with-python',
  'google-people-management-essentials',
  'ibm-data-analyst-r-excel',
  'ibm-data-manager',
  'ibm-isc2-cybersecurity-specialist',
  'jhu-data-science',
  'learn-korean',
  'microsoft-data-visualization',
  'pearson-pmp-certification',
  'programming-python-java',
  'retrieval-augmented-generation-rag',
  'sales-development-representative',
  'salesforce-sales-operations',
  'software-engineering-fundamentals',
  'statistical-inference-for-data-science-applications',
  'tableau-business-intelligence-analyst',
  'wharton-success',
];

const TOP_AI_PROGRAM_SLUGS: readonly string[] = [
  'google-ai',
  'ai-essentials-google',
  'machine-learning-introduction',
  'ibm-data-science',
  'google-advanced-data-analytics',
  'ibm-generative-ai-engineering',
  'ai-healthcare',
  'ibm-rag-and-agentic-ai',
  'deep-learning',
  'prompting-essentials-google',
  'microsoft-excel-skills',
  'ai-for-business-wharton',
  'ai-for-everyone',
  'ai-engineer',
  'applied-artifical-intelligence-ibm-watson-ai',
  'microsoft-data-analysis-sql-excel-powerbi',
  'microsoft-ai-product-manager',
  'adobe-graphic-designer',
  'microsoft-sql-server',
  'ibm-ai-product-manager',
  'prompt-engineering',
  'microsoft-ai-and-ml-engineering',
  'ibm-machine-learning',
  'generative-ai-for-leaders',
  'introduction-to-generative-ai',
  'ai-foundations-for-everyone',
  'generative-ai-for-everyone',
  'real-world-ai-for-everyone',
  'building-ai-agents-and-agentic-workflows',
  'microsoft-365-copilot-for-productivity',
  'adobe-content-creator',
  'ai-foundations-business-professionals',
  'ai-product-management-duke',
  'ai-agents',
  'generative-ai-software-engineering',
  'financialengineering',
  'ai-agents-for-leaders',
  'claude-ai-tools-for-beginners',
  'microsoft-365-copilot',
  'generative-ai-strategic-leader',
  'ai-governance-iso42001-readiness-grc-audit-legal',
  'mlops-machine-learning-duke',
  'generative-ai-for-growth-marketing',
  'generative-ai-for-software-development',
  'introduction-data-science',
  'microsoft-ai-business-professional',
  'ai-automation-engineer-n8n',
  'microsoft-generative-ai-engineering',
  'pytorch-for-deep-learning',
  'adobe-marketing-specialist',
  'generative-ai-with-llms',
  'machine-learning-specialization',
  'natural-language-processing',
  'ai-infrastructure-operations-fundamentals',
  'chatgpt-free-ai-tools-to-excel',
  'microsoft-ai-transformation-leader',
  'generative-ai-engineering-with-llms',
  'biostatistics-public-health',
  'build-anything-with-ai',
  'microsoft-copilot-your-everyday-ai-companion',
  'microsoft-genai-for-data-analysis',
  'financialtechnology',
  'statistical-analysis-r-public-health',
  'ai-for-medicine',
  'generative-ai-for-digital-marketing',
  'ai-financial-services-foundations-future-trends',
  'mastering-claude-ai-prompting-apis-rag-and-mcp',
  'vibe-coding',
  'reinforcement-learning',
  'ibm-deep-learning-with-pytorch-keras-tensorflow',
  'machine-learning',
  'gemini-for-google-workspace',
  'microsoft-ai-agents',
  'seo-mastery-from-fundamentals-to-genai-and-geo-strategies',
  'claude-code-in-action',
  'self-driving-cars',
  'tensorflow-in-practice',
  'microsoft-azure-ai-900-ai-fundamentals',
  'ai-builder',
  'generative-ai-for-project-managers',
  'investment-management-python-machine-learning',
  'meta-community-management',
  'generative-ai-for-software-developers',
  'generative-ai-for-executives-and-business-leaders',
  'computer-vision-cu',
  'large-language-model-operations',
  'critical-thinking-and-decision-science',
  'preparing-for-google-cloud-machine-learning-engineer-professional-certificate',
  'generative-ai-for-human-resources',
  'generative-ai-data-analyst',
  'aws-generative-ai-developers',
  'computational-neuroscience',
  'ibm-intro-machine-learning',
  'ai-agents-python',
  'google-accelerate-your-job-search-with-ai',
  'organizational-strategy-generative-ai',
  'enterprise-ai-data-engineering-databricks',
  'ai-for-finance',
];

const TRENDING_NOW_SLUGS: readonly string[] = [
  'google-cybersecurity',
  'google-it-support',
  'google-project-management',
  'hrci-human-resources-professional',
  'ibm-financial-planning-analysis-ai-skills',
  'facebook-social-media-marketing',
  'google-digital-marketing-ecommerce',
  'cbrops',
  'supply-chain-management',
  'positivepsychology',
  'microsoft-it-support-specialist',
  'microsoft-365-foundations-work-meet-share-create',
  'ibm-technical-support',
  'microsoft-power-bi-and-power-platform-productivity',
  'wharton-business-foundations',
  'social-science',
  'bi-essentials-for-finance-professionals-powerbi',
  'financial-management',
  'devops-and-software-engineering',
  'ux-design',
  'adobe-digital-marketing-strategy',
  'pmp-exam-prep-certification-training',
  'meem-project-management',
  'become-an-emt',
  'english-intermediate-b1',
  'amazon-junior-software-developer',
  'hotel-management',
  'strategic-management',
  'regulatory-compliance',
  'cfi-valuation-modeling',
  'manage-security-risks',
  'finance-and-financial-markets',
  'stanford-statistics',
  'uva-darden-digital-product-management',
  'ibm-cybersecurity-analyst',
  'ibm-business-analyst-professional-certificate',
  'neurobiology',
  'business-analytics',
  'negotiation',
  'ec-council-information-security-analyst',
  'mathematics-engineers',
  'principles-of-economics',
  'high-performance-leadership',
  'learn-sql-basics-data-science',
  'leading-modern-day-business',
  'introduction-to-learning-experience-design',
  'google-cloud-data-analytics-certificate',
  'g-suite-administration',
  'backend-javascript-developer',
  'marketing-strategy',
  'microsoft-cloud-support-associate',
  'business-financial-management',
  'microsoft-public-relations',
  'ibm-systems-and-solutions-architect',
  'aws-cloud-practitioner-essentials',
  'indigenous-canada',
  'french-beginner',
  'finance-accounting',
  'financial-instruments-trading-investing',
  'microsoft-azure-security-engineer-associate',
  'unilever-supply-chain-data-analyst',
  'estimating-and-bidding-in-construction',
  'it-fundamentals-cybersecurity',
  'aws-fundamentals',
  'snowflake-data-engineering',
  'meta-android-developer',
  'ibm-project-manager',
  'engineering-project-management',
  'money-banking',
  'gestion-de-proyectos-de-google',
  'ibm-it-project-manager',
  'business-statistics-analysis',
  'business-management-essentials',
  'supply-chain-excellence',
  'united-states-federal-taxation',
  'sas-programming',
  'hsk-learn-chinese',
  'ibm-product-manager',
  'preparation-comptia-certification',
  'nursing-prerequisites-essential-sciences-for-future-nurses',
];

// Program list as of August 2026
// @see https://docs.google.com/spreadsheets/d/1ii3J_KcVG1yYS-Jjx3zHyU0oC_fGY6INHq5Sh-XUwkk
export const MARKETING_TAG_SLUG_LISTS: readonly MarketingTagSlugList[] = [
  ['job-ready', JOB_READY_SLUGS],
  ['job-skills', JOB_SKILLS_SLUGS],
  ['bestseller', BESTSELLER_SLUGS],
  ['trending-now', TRENDING_NOW_SLUGS],
  ['top-ai-program', TOP_AI_PROGRAM_SLUGS],
];

export const buildMarketingTagSlugMap = (
  lists: readonly MarketingTagSlugList[]
): {
  map: Record<string, MarketingTagCategory>;
  collisions: Array<{ slug: string; from: MarketingTagCategory; to: MarketingTagCategory }>;
} => {
  const map: Record<string, MarketingTagCategory> = {};
  const collisions: Array<{ slug: string; from: MarketingTagCategory; to: MarketingTagCategory }> = [];

  for (const [category, slugs] of lists) {
    for (const slug of slugs) {
      const existing = map[slug];
      if (existing && existing !== category) {
        collisions.push({ slug, from: existing, to: category });
      }
      map[slug] = category;
    }
  }

  return { map, collisions };
};

let marketingTagSlugMap: Record<string, MarketingTagCategory> | undefined;

const getMarketingTagSlugMap = (): Record<string, MarketingTagCategory> => {
  if (!marketingTagSlugMap) {
    // build a map if not cached
    marketingTagSlugMap = buildMarketingTagSlugMap(MARKETING_TAG_SLUG_LISTS).map;
  }
  return marketingTagSlugMap;
};

// Shared tag category colors. Values from the approved design.
export const topAiProgramColors = {
  backgroundColor: 'var(--cds-color-purple-100)',
  color: 'var(--cds-color-purple-950)',
};

export const trendingNowColors = {
  backgroundColor: 'var(--cds-color-red-100)',
  color: 'var(--cds-color-red-850)',
};

// tagName is kept as the pre-existing, stable analytics identifier for each category — it does
// not follow display-text casing changes, so tracking stays continuous with historical data.
const getMarketingTagContent = (category?: MarketingTagCategory): MarketingStatusTag | undefined => {
  switch (category) {
    case 'job-ready':
      return { tag: _t('Job ready'), tagName: 'Job Ready', category };
    case 'job-skills':
      return { tag: _t('Job skills'), tagName: 'Job Skills', category };
    case 'bestseller':
      return { tag: _t('Bestseller'), tagName: 'Bestseller', category };
    case 'top-ai-program':
      return { tag: _t('Top AI program'), tagName: 'Top AI Program', category };
    case 'trending-now':
      return { tag: _t('Trending right now'), tagName: 'Trending right now', category };
    default:
      return undefined;
  }
};

export const getMarketingStatusTagForSlug = (slug: string): MarketingStatusTag | undefined => {
  const category = getMarketingTagSlugMap()[slug];
  return getMarketingTagContent(category);
};
